import {createRootRouteWithContext, createRoute, createRouter} from "@tanstack/react-router"
import {QueryClient} from "@tanstack/react-query"
import {Auth} from "@/library/auth/auth-context"
import RootLayout from "@/components/layout/layout.root"
import {authRoute, indexRoute, signInRoute} from "@/routing/routes.general"
import {publicChangelogRoute, publicRefKeyChangelogRoute} from "@/routing/routes.public"
import {changesRoute, employeesRoute, newsRoute, portalRoute, refKeyChangesRoute} from "@/routing/routes.portal"
import NotFound404 from "@/pages/errors/404-not-found"
import TestPage from "@/pages/test"

export type RouteContext = {
    queryClient: QueryClient,
    auth: Auth
}
export const rootRoute = createRootRouteWithContext<RouteContext>()({
    component: RootLayout
})

const routeTree = rootRoute.addChildren([
    indexRoute,
    authRoute.addChildren([
        signInRoute
    ]),
    portalRoute.addChildren([
        newsRoute,
        changesRoute,
        refKeyChangesRoute,
        employeesRoute
    ]),
    publicChangelogRoute,
    publicRefKeyChangelogRoute,
    createRoute({
        path: "/testing",
        getParentRoute: () => rootRoute,
        component: TestPage
    })
])

export const router = (context: RouteContext) => createRouter({
    routeTree,
    context: context,
    defaultPreload: 'intent',
    defaultPreloadStaleTime: 0,
    defaultNotFoundComponent: NotFound404
})

declare module '@tanstack/react-router' {
    interface Register {
        router: typeof router
    }
}
